import * as moment from 'moment';

export enum CalendarDeviceMode {
    DESKTOP,
    MOBILE
}

export enum CalendarViewMode {
    GRID,
    LIST
}

export interface ICalendarSettings {
    loadWrappingMonthDates: boolean;
    saveHistory: boolean;
    monthsOnCalendar: moment.Moment[];
    calendarDeviceMode: CalendarDeviceMode;
    calendarViewMode: CalendarViewMode;
    desktopToMobileTransitionWidth: string;
    scrollToTopAppearanceOffset: number;
    filtersAlwaysModal: boolean;
}

const calendarEntry = document.getElementById("calendar-entry-js");

export const defaultCalendarSettings: ICalendarSettings = {
    //Update loadWrappingMonthDates to true after any Calendar upgrade
    loadWrappingMonthDates: false,
    saveHistory: false,
    monthsOnCalendar: [],
    calendarDeviceMode: CalendarDeviceMode.DESKTOP,
    calendarViewMode: CalendarViewMode.GRID,
    desktopToMobileTransitionWidth: calendarEntry && calendarEntry.getAttribute("data-calendar-breakpoint") ? calendarEntry.getAttribute("data-calendar-breakpoint") : "80em",
    scrollToTopAppearanceOffset: parseInt(calendarEntry && calendarEntry.getAttribute("data-scroll-to-top-offset") ? calendarEntry.getAttribute("data-scroll-to-top-offset") : "500"),
    filtersAlwaysModal: calendarEntry && Boolean(calendarEntry.getAttribute("data-filter-always-modal")) ? Boolean(calendarEntry.getAttribute("data-filter-always-modal")) : false
}